<template>
  <van-popup
    class="staff"
    v-model="showModal"
    position="bottom"
    round
    :style="{ height: '90%' }"
  >
    <van-search
      show-action
      autofocus
      v-model="value"
      @search="onSearch"
    >
      <template #action>
        <van-button @click="onSearch" size="small">搜索</van-button>
      </template>
    </van-search>
    <van-cell-group>
      <van-cell v-for="item in list" :key="item.id" :title="item.name" :value="item.tel" @click="handleClick(item)" />
    </van-cell-group>
  </van-popup>
</template>

<script>
export default {
  name: 'StaffModal',
  props: {
    visible: {
      require: true,
      type: Boolean
    },
    staffList: {
      require: true,
      type: Array
    }
  },
  data() {
    return {
      value: '',
      filterStr: ''
    }
  },
  computed: {
    list() {
      return this.staffList.filter(item => {
        if (this.filterStr) {
          return item.name.includes(this.filterStr) || item.tel.includes(this.filterStr)
        }
        return item;
      });
    },
    showModal: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  methods: {
    onSearch() {
      this.filterStr = this.value;
    },
    handleClick(item) {
      this.$emit('update:visible', false);
      this.$emit('modifyUserId', item);
    }
  }
}
</script>

<style lang="less" scoped>
.staff {
  .van-cell-group { height: calc(~'100% - 64px'); overflow: auto; }
}
</style>